import { APIBASE } from '../../../constants/api.constants'
import { APIROUTES, fillPath } from '../../../constants/routes.constants'

/**
 * Build (store-builder) media helpers — parallel to shopMedia.tsx but
 * targets the /build/media/:id endpoint so the URL surface stays clean
 * for the future selection + publish-sub-domain flow.
 */

export function buildMediaUrl(mediaId: string): string {
  return `${APIBASE}${fillPath(APIROUTES.BUILDMEDIA, { id: mediaId })}`
}

export function isVideo(contentType: string): boolean {
  return contentType.startsWith('video/')
}

export function PlayBadge(): JSX.Element {
  return (
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-bg-primary/85 shadow-sm">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="text-charcoal" aria-hidden>
        <path d="M8 5v14l11-7z" />
      </svg>
    </span>
  )
}
